import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import MainScreen from '@/components/mainScreen/MainScreen'
import ResultList from '@/components/campaignList/ResultList'

import CampaignMain from '@/components/campaign/camMain/CampaignMain'
import AdMain from '@/components/campaign/contract/AdMain'
import SizeMain from '@/components/campaign/size/SizeMain'
import CreativeMain from '@/components/campaign/creative/CreativeMain'
import CgMain from '@/components/campaign/creativeGroup/CgMain'
import GeoMain from '@/components/campaign/geo/GeoMain'
import Overview from '@/components/campaign/camMain/Overview'

import PageNotFound from '@/components/PageNotFound'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/interview/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: MainScreen
    },
    {
      path: '/campaignlist',
      name: 'campaignList',
      component: ResultList
    },
    {
      path: '/campaign',
      component: CampaignMain,
      children: [
        {
          path: '',
          component: Overview
        },
        {
          path: 'ad',
          component: AdMain
        },
        {
          path: 'size',
          component: SizeMain
        },
        {
          path: 'creative',
          component: CreativeMain
        },
        {
          path: 'creativeGroup',
          component: CgMain
        },
        {
          path: 'geo',
          component: GeoMain
        }
      ]
    },
    {
      path: '/*',
      name: 'pageNotFound',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js